export const notification = {
  signedInSuccessfully: (firstName) =>
    `Dear ${firstName}! You are successfully signed in!`,
  signedOutSuccessfully: `You are signed out successfully!`,

  // user
  userSuccessfullyCreated: (code: string, name: string) =>
    `User ${name} (${code}) is successfully created`,
  userSuccessfullyUpdated: 'User data is successfully updated!',
  userPasswordSuccessfullyChanged: 'User password is successfully changed!',
  userSuccessfullyDeleted: 'User is successfully deleted',

  // offer
  offerSuccessfullyCreated: (name: string) =>
    `Offer (${name}) is successfully created`,
  offerIsBlockedBy: (name: string) => `Offer is blocked by ${name}`,
  offerSuccessfullyUpdated: 'Offer data is successfully updated!',
  offerSuccessfullyDeleted: 'Offer is successfully deleted',
  copyOfferSuccess: 'Offer copy is successfully created',
  offerStatusSuccessChanged: 'Offer status is successfully changed',
  copyOfferTitle: 'Create offer copy',
  copyOfferMessage: 'Do you want to create copy of this offer?',

  // offer geo
  offerGeoSuccessfullySaved: 'Offer geo is successfully saved',
  offerGeoSuccessfullyDeleted: 'Offer geo is successfully deleted',

  // partners
  partnerSuccessfullySaved: (name: string) =>
    `Partner ${name} is successfully saved`,
  partnerSuccessfullyUpdated: 'Partner data is successfully updated!',
  partnerSuccessfullyDeleted: 'Partner is successfully deleted',
  partnerGeoECPMSuccessfullyUpdated: 'Partners Geo ECPM has been updated',
  partnerGeoECPMSuccessfullyDeleted: 'Partners Geo ECPM has been deleted',
};
